export default __webpack_public_path__ + "8c480e167b348f12e13f14ec6d7feada.png";